import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=085e8e03"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085e8e03')) {
      api.createRecord('085e8e03', component.options)
    } else {
      api.reload('085e8e03', component.options)
    }
    module.hot.accept("./ProjectEdit.vue?vue&type=template&id=085e8e03", function () {
      api.rerender('085e8e03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/ProjectEdit.vue"
export default component.exports